/* unplugin-vue-components disabled */import script from "./PopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./PopUp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__